import { isNull } from 'lodash';
import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from 'src/utils/api';
import { TransactionLimitState } from './types';

const TRANSACTION_LIMITS = 'TRANSACTION_LIMITS';

export default function transactionLimits(
  state: TransactionLimitState = {
    hasError: false,
    isLoading: false,
    isLoaded: false,
    error: null,
    transactionLimits: [],
  },
  { payload, type }
) {
  switch (type) {
    case `${TRANSACTION_LIMITS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case `${TRANSACTION_LIMITS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactionLimits: isNull(payload.body) ? [] : payload.body,
      };
    case `${TRANSACTION_LIMITS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: payload,
      };
    default:
      return state;
  }
}

export const getTransactionLimits = () => {
  return () => {
    const action = createAction(TRANSACTION_LIMITS)(
      callApi(`${getEndpoint('transactionLimits')}?transactionType=redeem`)
    );
    return action;
  };
};
